import React from 'react';
import { Box, Button, Chip, Stack, Typography } from '@mui/material';
import AssignmentIcon from '@mui/icons-material/Assignment';
import TransactionCard from './transactionCard';
import { addCommas } from '../../../components/converter';

const TransactionsTab = ({
  items = [],
  totalCount = 0,
  balanceAmount,
  loadingMore,
  onLoadMore,
}) => {
  const tomanBalance =
    balanceAmount === undefined || balanceAmount === null
      ? null
      : addCommas(Math.floor(Number(balanceAmount) / 10) || 0);

  return (
    <Box sx={{ width: '100%', px: '20px', pb: 3 }}>
      {tomanBalance !== null && (
        <Chip
          sx={{ mt: 2, mb: 1, borderRadius: '8px' }}
          label={`موجودی: ${tomanBalance} تومان`}
        />
      )}
      {items.length > 0 ? (
        <>
          <Typography
            variant="subtitle2"
            textAlign="left"
            sx={{ mt: 1, mb: 1.5 }}
          >
            تعداد: {totalCount || items.length}
          </Typography>
          {items.map((item, index) => (
            <TransactionCard
              key={item?.transactionID || item?.referenceNo || index}
              item={item}
            />
          ))}
          {items.length < totalCount && (
            <Button
              fullWidth
              variant="outlined"
              sx={{ mt: 1 }}
              disabled={loadingMore}
              onClick={onLoadMore}
            >
              {loadingMore ? 'در حال بارگذاری...' : 'موارد بیشتر'}
            </Button>
          )}
        </>
      ) : (
        <Stack
          justifyContent="center"
          alignItems="center"
          width="100%"
          height="220px"
        >
          <AssignmentIcon sx={{ fontSize: '80px' }} color="disabled" />
          <Typography variant="h6" color="textSecondary">
            تراکنشی ثبت نشده است
          </Typography>
        </Stack>
      )}
    </Box>
  );
};

export default TransactionsTab;
